// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__3HxqQ","icon":"SortAdornment_icon__27jRI","up":"SortAdornment_up__3E_Ab","down":"SortAdornment_down__1XWe3","active":"SortAdornment_active__3UNqM"};